import React from 'react';
import pt from 'prop-types';
import Text from '../../../../ui/text';
import Link from '../../../../ui/link';
import * as styles from './styles.module.scss';
import Icon from '../../../../ui/icon';

const PdfDownload = ({ file, title, language, redesign }) => {
  return (
    <div className={styles.pdfDownload}>
      <Icon name="file-pdf" size="2x" />
      <div className={styles.fileContent}>
        <Link link={{ externalLink: file.url }}>
          <Text
            as="span"
            type={redesign ? 'p2' : 'p1'}
            variant="semibold"
            className={styles.link}
          >
            {title}
          </Text>
          <Text as="span" type={redesign ? 'p2' : 'p1'}>
            {`${language} (${file.contentType
              .split('/')
              .pop()
              .toUpperCase()}  ${(file.details.size / 1000).toFixed(0)} KB)`}
          </Text>
        </Link>
      </div>
    </div>
  );
};

PdfDownload.propTypes = {
  file: pt.object.isRequired,
  title: pt.string.isRequired,
  language: pt.string,
  redesign: pt.bool, // Added for softlaunch redesign
};

export default PdfDownload;
